import Rete from 'rete'

import OtnSingleTemplate from './OtnSingleTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class OtnSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.OTN_SINGLE)
    
    this.data.component = OtnSingleTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
  }

  builder(node) {
    node.lingualName = lingualName.OTN_SINGLE
    this.setConnection()
    
    const otnSingleInput = new Rete.Input(CONST_SOCKET.OTN_SINGLE_INPUT, lang.otn_single_socket_input_reply, this.socket.otnSingleInput, false)
    const otnSingleOutput = new Rete.Output(CONST_SOCKET.OTN_SINGLE_OUTPUT, lang.otn_single_socket_output_next, this.socket.otnSingleOutput, false)
    
    node.addInput(otnSingleInput)
    node.addOutput(otnSingleOutput)
    
    if (this.isSequenceAddonAvailable) {
      const otnSingleOutputSequence = new Rete.Output(
        CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE, 
        lang.otn_single_socket_output_next_sequence, 
        this.socket.otnSingleOutputSequence, 
        false
      )

      node.addOutput(otnSingleOutputSequence)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.OTN_SINGLE_OUTPUT] = node.data
  }

  setConnection() {
    // OTN may be connected to:
    this.socket.otnSingleOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.otnSingleOutput.combineWith(this.socket.openaiInput)
    this.socket.otnSingleOutput.combineWith(this.socket.carouselInput)
    this.socket.otnSingleOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.otnSingleOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.otnSingleOutput.combineWith(this.socket.videoInput)
      this.socket.otnSingleOutput.combineWith(this.socket.audioInput)
      this.socket.otnSingleOutput.combineWith(this.socket.fileInput)
      this.socket.otnSingleOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.otnSingleOutput.combineWith(this.socket.rcnInput)
    }

    this.socket.otnSingleOutput.combineWith(this.socket.ecommerceInput)
    this.socket.otnSingleOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.otnSingleOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.otnSingleOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.otnSingleOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.otnSingleOutput.combineWith(this.socket.conditionInput)
    }


  }
}